const gallery = [
	{
		id: 1,
		name: 'London',
		image: '/assets/gallery/london.jpg',
	},
	{
		id: 2,
		name: 'London',
		image: '/assets/gallery/london2.jpg',
	},
	{
		id: 3,
		name: 'Turkey',
		image: '/assets/gallery/turkey.jpg',
	},
	{
		id: 4,
		name: 'Thailand',
		image: '/assets/gallery/thailand.jpg',
	},
	{
		id: 5,
		name: 'Thailand',
		image: '/assets/gallery/thailand2.jpg',
	},
	{
		id: 6,
		name: 'Spain',
		image: '/assets/gallery/spain.jpg',
	},
	{
		id: 7,
		name: 'Spain',
		image: '/assets/gallery/spain2.jpg',
	},
	{
		id: 8,
		name: 'Switzerland',
		image: '/assets/gallery/switzerland.jpg',
	},
	{
		id: 9,
		name: 'Switzerland',
		image: '/assets/gallery/switzerland2.jpg',
	},
	{
		id: 10,
		name: 'France',
		image: '/assets/gallery/france.jpg',
	},
	{
		id: 11,
		name: 'United State of America',
		image: '/assets/gallery/usa.jpg',
	},
	{
		id: 12,
		name: 'Pakistan',
		image: '/assets/gallery/pakistan.jpg',
	},
];
export default gallery;
